// import Vue from 'vue'
const state = {
    uploadFileList: [],
    bucketKey: '',
};

const actions = {
};

const mutations = {
    SET_UPLOAD_FILELIST(state, uploadFileList) {
        state.uploadFileList = uploadFileList;
    },
    SET_BUCKETKEY(state, bucketKey) {
        state.bucketKey = bucketKey;
    },
};

export default {
    state,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/storage.js